// extracted by mini-css-extract-plugin
export default {"container":"MultiSelectInput_container__v-Ptn"};